import * as React from "react"
import { ShopItem } from "types/shop"
import { Picture, Typography, Price } from "components"
import { Link } from "react-router-dom"
import "./shopResult.scss"

interface ShopResult {
	items: ShopItem[]
}

const ShopResult: React.FC<ShopResult> = ({ items }) => {
	return (
		<ul className="d-flex flex-wrap p-0 shop-result">
			{items.map((item) => (
				<li key={item.id} className="shop-result__li flex-column p-2">
					<Link
						to={{
							pathname: `/product/NAP-${item.product_id}/${item.url}`,
							state: item.id,
						}}
					>
						<Picture
							className="shop-result__image d-flex justify-content-center align-items-center mb-2"
							src={"https://antivirus.ir" + item.image}
						/>
						<Typography gutterBottom variant="body2" color="dark">
							{item.name_fa}
						</Typography>
						<Price symbool discount={item.old_price}>
							{item.price}
						</Price>
					</Link>
				</li>
			))}
		</ul>
	)
}

export default ShopResult
